import { gql } from '@provision/graphql-client';

const CG_CUSTOM_DOMAIN_FIELDS = gql`
  fragment CgCustomDomainFields on CgCustomDomain {
    partnerCustomDomainId
    brandIds
    hostname
    status
    cnameTarget
    lastCheckedAt
    routingRecord
  }
`;

export const GET_CG_CUSTOM_DOMAINS_QUERY = gql`
  query GetCgCustomDomains($input: GetCgCustomDomainsInput!) {
    getCgCustomDomains(input: $input) {
      ...CgCustomDomainFields
    }
  }
  ${CG_CUSTOM_DOMAIN_FIELDS}
`;

export const ADD_PARTNER_CG_CUSTOM_DOMAIN_MUTATION = gql`
  mutation AddPartnerCgCustomDomain($input: AddPartnerCgCustomDomainInput!) {
    addPartnerCgCustomDomain(input: $input) {
      ...CgCustomDomainFields
    }
  }
  ${CG_CUSTOM_DOMAIN_FIELDS}
`;

export const CHECK_CG_CUSTOM_DOMAIN_NOW_MUTATION = gql`
  mutation CheckCgCustomDomainNow($input: CgCustomDomainInput!) {
    checkCgCustomDomainNow(input: $input) {
      ...CgCustomDomainFields
    }
  }
  ${CG_CUSTOM_DOMAIN_FIELDS}
`;

export const REMOVE_CG_CUSTOM_DOMAIN_MUTATION = gql`
  mutation RemoveCgCustomDomain($input: CgCustomDomainInput!) {
    removeCgCustomDomain(input: $input)
  }
`;

export const SET_CG_CUSTOM_DOMAIN_SEGMENTS_MUTATION = gql`
  mutation SetCgCustomDomainSegments($input: SetCgCustomDomainSegmentsInput!) {
    setCgCustomDomainSegments(input: $input) {
      ...CgCustomDomainFields
    }
  }
  ${CG_CUSTOM_DOMAIN_FIELDS}
`;
